<template lang='pug'>
.industry-list-panel
    .title {{ level1 }}
    SectionPanel(v-if='options.length' :options='options')
</template>

<script>
import SectionPanel from './components/Panel/SectionPanel'
import dataDic from '@/assets/data/dic'
import { getDataHierarchy, getDataRows, getPathNames } from '@custouch/proxy-use'

export default {
    props: ['hId'],
    data() {
        return {
            options: [],
            level1: ''
        }
    },
    components: {
        SectionPanel
    },
    async created() {
        const { DATA } = window.env
        const { template } = DATA
        const [ret,{data},title] = await Promise.all([
            getDataHierarchy({dataHierarchyId: this.hId}),
            getDataRows({
                dataHierarchyId: this.hId,
                dataTemplateId: template.productTech,
                index: 1,
                size: 30
            }),
            getPathNames(this.hId)
        ])
        this.level1 = ret.name
        this.options = data.map(item=> {
            return Object.assign({img: item.detail.banner,text: item.detail.name,to: {name: 'productDetail', params: {rId: item.id},query: {hId: this.hId}}})
        })
        this.$root.$emit('pageview',{
            title
        })
        // const data = await this.$store.dispatch('getJson', dataDic['行业应用'])
        // this.options = data.reduce((pre, cur) => {
        //     if (cur.level1 === this.level1) {
        //         pre.push({ img: cur.banner, text: cur.name, to: { name: 'productDetail', params: { section: '行业应用', name: cur.name } } })
        //     }
        //     return pre
        // }, [])
    },
}
</script>

<style scoped lang='less'>
.industry-list-panel {
    padding: 1.2rem 1rem;
}
.title {
    text-align: center;
    color: #404040;
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 1.2rem;
}
</style>